module.exports = __webpack_public_path__ + "static/media/R-360HD_CrossSection.18ff3657.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/R-360HD_CrossSection.png
// module id = 489
// module chunks = 0